import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PlainHTMLDialog from 'components/dialogs/PlainHTMLDialog';
import useModal from 'hooks/useModal';
import { MailTemplateData, MailTemplateModel } from 'models/Mailings';
import TemplateDialog from 'modules/mailings/dialogs/TemplateDialog';
import Api from 'utils/api';
import { removeItemAtIndex, replaceItemAtIndex } from 'utils/common';


const useMailTemplates = () => {
    const {t} = useTranslation();
    const {showModal, hideModal} = useModal();
    const [templates, setTemplates] = useState<MailTemplateModel[]>([]);

    useEffect(() => {
        Api.mailings.templates()
            .then(setTemplates);
    }, []);

    const create = (data: MailTemplateData) => Api.mailings.createTemplate(data)
        .then(data => setTemplates(old => [data, ...old]))

    const update = (data: MailTemplateModel) => Api.mailings.updateTemplate(data)
        .then(data => setTemplates(old => replaceItemAtIndex(old, old.findIndex(i => i.id === data.id), data)));

    const remove = (id: number) => Api.mailings.deleteTemplate(id)
        .then(() => setTemplates(old => removeItemAtIndex(old, old.findIndex(i => i.id === id))));

    const openAddTemplateModal = () => showModal(TemplateDialog,
        {},
        {
            title: t('add_title', {value: t('template')}),
            maxWidth: 'md',
            fullWidth: true,
        })
        .then(create)
        .then(hideModal);

    const openEditTemplateModal = (template: MailTemplateModel) => showModal(TemplateDialog,
        {template},
        {
            title: t('edit_title', {value: t('template')}),
            maxWidth: 'md',
            fullWidth: true,
        })
        .then(data => update({...data, id: template.id}))
        .then(hideModal);

    const openPreviewModal = (subject: string, html: string) => showModal(PlainHTMLDialog,
        {html},
        {
            title: subject,
            maxWidth: 'md',
            fullWidth: true,
        }
    );

    return {
        templates,
        openAddTemplateModal,
        openEditTemplateModal,
        remove,
        openPreviewModal,
    }
};

export default useMailTemplates;
